var _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRackServers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63.25,
    y: 36,
    width: 1.5,
    height: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.25,
    y: 36,
    width: 1.5,
    height: 8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 63.25,
    y: 20,
    width: 1.5,
    height: 8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.25,
    y: 20,
    width: 1.5,
    height: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,64.75H70a.7502.7502,0,0,0,.75-.75V16a.7502.7502,0,0,0-.75-.75H10a.7502.7502,0,0,0-.75.75V64A.7502.7502,0,0,0,10,64.75Zm.75-48h58.5v14.5H10.75Zm0,16h58.5v14.5H10.75Zm0,16h58.5v14.5H10.75Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63.25,
    y: 52,
    width: 1.5,
    height: 8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.25,
    y: 52,
    width: 1.5,
    height: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 24,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 40,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 56,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRackServers);
export default __webpack_public_path__ + "static/media/icon_rack_servers.86cb6ca3dc88a6f9c6fc6934f62a0968.svg";
export { ForwardRef as ReactComponent };